import React, { useEffect, useState } from 'react';
import { SECTIONS } from '@/lib/depth';
import { Atmosphere } from '@/components/Atmosphere';
import { AmbientWorld } from '@/components/AmbientWorld';
import { DioramaZoom } from '@/components/DioramaZoom';
import { AboutOverlay } from '@/components/AboutOverlay';
import { PartnershipsOverlay } from '@/components/PartnershipsOverlay';
import { VideoCharacter } from '@/components/VideoCharacter';
import { ParticleField } from '@/components/ParticleField';
import { CursorLight } from '@/components/CursorLight';
import { Navbar } from '@/components/Navbar';
import DepthExperience from '@/components/DepthExperience';
import MobileExperience from '@/components/MobileExperience';

const useIsDesktop = () => {
  const [isDesktop, setIsDesktop] = useState(() =>
    typeof window !== 'undefined' ? window.matchMedia('(min-width: 768px)').matches : true
  );
  useEffect(() => {
    const mq = window.matchMedia('(min-width: 768px)');
    const onChange = (e) => setIsDesktop(e.matches);
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, []);
  return isDesktop;
};

export default function Home() {
  const isDesktop = useIsDesktop();

  const handleNavigate = (id) => {
    if (isDesktop) {
      const s = SECTIONS.find((x) => x.id === id);
      window.scrollTo({ top: s ? s.depth : 0, behavior: 'smooth' });
    } else if (id === 'hero') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      const el = document.getElementById(`m-${id}`);
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <div className="relative min-h-screen bg-background">
      <DioramaZoom />
      <Atmosphere />
      <AmbientWorld />
      <ParticleField dense={isDesktop} />
      <Navbar onNavigate={handleNavigate} />
      {isDesktop && <AboutOverlay />}
      {isDesktop && <VideoCharacter />}
      {isDesktop && <PartnershipsOverlay />}
      {isDesktop ? <DepthExperience /> : <MobileExperience />}
      <div className="noise-overlay" aria-hidden="true" />
      <CursorLight />
    </div>
  );
}
